import React, {useEffect} from "react";
import {Card, Tabs} from "antd";
import {ProfileTwoTone} from "@ant-design/icons";
import SupplierBillList from "./SupplierBillList";
import SupplierAccountList from "./SupplierAccountList";
import SupplierRechargeList from "./SupplierRechargeList"//充值记录
import {useModel} from "../../../models";
import BalanceList from "./balance/BalanceList";

const Title = () => {
    let [{accountToatl, selectedSupplierBill}, {}] = useModel("supplierBill")
    return (
        <div style={{display: "flex"}}>
            <h3 style={{flex: "1"}}>
                <ProfileTwoTone/>
                <span className="margin-left-8">{selectedSupplierBill ? selectedSupplierBill.supplierName : ""}</span>
                <span className="margin-left-16 color-green">
                    可用额度 {accountToatl ? accountToatl.availableCreditTotal : "0.00"}
                </span>
                <span className="margin-left-16 color-red">
                    欠款 {accountToatl ? accountToatl.arrears : "0.00"}
                </span>
            </h3>
        </div>
    )
}
export default function () {
    let [{tabsKey}, {setTabsKey}] = useModel("supplierBill")
    const TabClick = (key, event) => {
        // console.log(key,event)
    }
    const onChange = (active) => {
        // console.log(active,"////////////////")
        // debugger
        setTabsKey(active)
    }
    useEffect(() => {
        setTabsKey(tabsKey)
    }, [])
    const TabPane = [
        {key: "recharge", name: "充值记录"},
        {key: "resizeLimit", name: "调额记录"},
        {key: "transferAccounts", name: "转账记录"},
    ]
    return (
        <Card
            title={<Title/>}
            bordered={true}
            className="margin-top-8"
        >
            {/* <SupplierForm/> */}
            <Tabs tabPosition="top"
                  onTabClick={TabClick}
                  onChange={onChange}
                  activeKey={tabsKey}
            >
                <Tabs.TabPane tab="账户信息" key="1">
                    <SupplierAccountList/>
                </Tabs.TabPane>

                {
                    TabPane.map(item => {
                        return (
                            <Tabs.TabPane tab={item.name} key={item.key}>
                                <SupplierRechargeList key={item.key} name={item.key}/>
                            </Tabs.TabPane>
                        )
                    })
                }
                <Tabs.TabPane tab="账单信息" key="2">
                    <SupplierBillList/>
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab="平帐记录" key="balanceList">
                    <BalanceList/>
                </Tabs.TabPane> */}
            </Tabs>
        </Card>
    )
}